/* eslint-disable */
import listing from "@/apollo/airlines/listing.gql";
import create_update from "@/apollo/airlines/create_update.gql";
import inventory_airlines from "@/apollo/airlines/inventory_airlines.gql";
import check_exists from "@/apollo/airlines/check_exists.gql";

export const state = () => ({
  list: [],
  loading: false,
  creating: false,
  airlines: []
});

export const mutations = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 11 Jul 2023 | 04:08PM
   * @param {*} state
   * @param {*} value
   */
  setListing: (state, value) => (state.list = value),
  /**
   * @description
   * @author Saurabh Jangra
   * @date 11 Jul 2023 | 04:08PM
   * @param {*} state
   * @param {*} value
   */
  setLoading: (state, value) => (state.loading = value),
  /**
   * @description
   * @author Saurabh Jangra
   * @date 11 Jul 2023 | 04:08PM
   * @param {*} state
   * @param {*} value
   */
  setCreating: (state, value) => (state.creating = value),

  /**
   * @description
   * @author Saurabh Jangra
   * @date 24 Jul 2023 | 01:13PM
   * @param {*} state
   * @param {*} value
   */
  setInventoryAirlines: (state, value) => (state.airlines = value)
};

export const actions = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 11 Jul 2023 | 04:07PM
   * @param {*} { commit }
   * @returns {*}
   */
  fetchListing({ commit }) {
    commit("setLoading", true);
    commit("setListing", []);
    return new Promise((resolve) => {
      this.$apolloClient
        .query({ query: listing })
        .then(({ data }) => {
          commit("setListing", data.fetch_airlines);
          resolve(data.fetch_airlines);
          commit("setLoading", false);
        })
        .catch((err) => {
          commit("setLoading", false);
        });
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 22 Jul 2023 | 04:52PM
   * @param {*} __
   * @param {*} payload
   * @returns {*}
   */
  checkAirlineExists(__, payload) {
    return new Promise((resolve) => {
      this.$apolloClient.query({ query: check_exists, variables: { payload } }).then(({ data }) => {
        resolve(data.check_airline_exists);
      });
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 24 Jul 2023 | 01:11PM
   * @returns {*}
   */
  inventoryAirlines({ commit }) {
    return new Promise((resolve) => {
      this.$apolloClient.query({ query: inventory_airlines }).then(({ data }) => {
        commit("setInventoryAirlines", data.inventory_airlines);
        resolve(data.inventory_airlines);
      });
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 22 Jul 2023 | 12:37PM
   * @param {*} { commit }
   * @param {*} payload
   * @returns {*}
   */
  createUpdate({ commit }, payload) {
    commit("setCreating", true);
    return new Promise(async (resolve) => {
      const _result = await this.$apolloClient
        .mutate({ mutation: create_update, variables: { payload } })
        .then(({ data }) => data.create_update_airline);
      commit("setCreating", false);
      if (_result) {
        resolve(_result);
      }
    });
  }
};

export const getters = {
  list: (state) => state.list,
  loading: (state) => state.loading,
  creating: (state) => state.creating,
  airlines: (state) => state.airlines
};
